export default "__VITE_ASSET__Bt8c3ABV__"